export const getTokenFromResponseV1 = (response) => {
    if (response.includes("ERROR")) {
        throw new Error(response);
    }
    const token = response.replace("ApiAccessToken = '", "").replace("'", "");
    if (!token) {
        throw new Error("Token is not available");
    }
    return token;
};
//# sourceMappingURL=GetTokenFromResponseV1.js.map